import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";
import { VerticalTimelineElement } from "react-vertical-timeline-component";

interface MyTimelineElementProps {
  date: string;
  title: string;
  employer: string;
  location: string;
  description: string;
}

export function MyTimelineElement({
  title,
  date,
  employer,
  location,
  description,
}: MyTimelineElementProps) {
  return (
    <VerticalTimelineElement
      className="vertical-timeline-element--work"
      contentStyle={{ background: "white", color: "rgb(39, 40, 34)" }}
      contentArrowStyle={{ borderRight: "7px solid  white" }}
      date={date}
      iconStyle={{ background: "#5000ca", color: "rgb(39, 40, 34)" }}
      icon={<FontAwesomeIcon icon={faBriefcase} />}
    >
      <h3 className="vertical-timeline-element-title">{title}</h3>
      <h4 className="vertical-timeline-element-subtitle">{employer}</h4>
      <h4
        className="vertical-timeline-element-subtitle"
        style={{ fontSize: "15px" }}
      >
        {location}
      </h4>
      <p>{description}</p>
    </VerticalTimelineElement>
  );
}
